<template>
  <div>
    <page-heading-info
      title="Board of Revision"
      phone="(740) 283-8518"
      courthouse="true"
      hours="8:30 - 4:30 (M-F)"
      floor="1st Floor, room 100">
    </page-heading-info>
    <div class="row">
      <div class="col-md-6 order-1 order-md-0">
        <div class="row">
          <div class="col-12 mt-3">
            <link-box
            bg-color="dark"
            dark="true"
            icon="description"
            icon-color="light"
            title-color="light"
            title="BOR Complaint Form"
            title-align="left"
            url="https://tax.ohio.gov/static/forms/real_property/dte-dte1.pdf">
            Click here to download the Board of Revision complaint form DTE1
            </link-box>
          </div>
          <div class="col-12 mt-3">
            <link-box
            bg-color="dark"
            dark="true"
            icon="description"
            icon-color="light"
            title-color="light"
            title="BOR Rules and Procedures"
            title-align="left"
            url="/static/departments/auditor/BOR-rules-of-practice-and-procedure.pdf">
            Click here to download the Board of Revision rules and procedures
            </link-box>
          </div>
          <div class="col-12 mt-3">
            <link-box
            bg-color="dark"
            dark="true"
            icon="search"
            icon-color="light"
            title-color="light"
            title="Real Estate Search"
            title-align="left"
            route="/auditor/real-estate">
            Click here to go to the Jefferson County Real Estate Search
            </link-box>
          </div>
          <div class="col-12 mt-3">
            <link-box
            bg-color="primary"
            dark="true"
            icon="table_rows"
            icon-color="light"
            title-color="light"
            title="Board of Revision Cases"
            title-align="left"
            route="/auditor/bor-complaints">
            </link-box>
          </div>
	</div>
      </div>
      <div class="col-md-6 mt-3 order-0 order-md-1">
	<p>
	  The Board of Revision (BOR) is a three person quasi-judicial
	  board comprised of a member from the offices of the County
	  Auditor, the County Treasurer, and the Board of County
	  Commissioners.
	</p>
	<p>
	  The BOR is responsible for conducting hearings to determine the
	  Fair Market Value of property. Property owners that disagree
	  with the valuation of their property can appeal to the
	  BOR. <i><b>To initiate a property value appeal, please complete
	  the BOR complaint form.</b></i>
	</p>
	<p>
	  Note: The BOR can only make changes to property values. It is
	  not able to change tax rates or tax amounts due.
	</p>
	<p>
	  The BOR filing period is <b>January 1 - March 31</b>.
	</p>
      </div>
    </div>
    <p>
      Due to changes in the Board of Revision process enacted by the State
      of Ohio in 2022, the BOR will no longer notify the local school
      board if an appeal is filed with a requested change of $50,000 or
      more.
    </p>
    <p>
      The currently serving board is comprised of Chairman Commissioner
      Jake Kleineke, Vice-Chairman Treasurer Brian Scarpone, and Secretary
      Auditor E.J. Conn.
    </p>
  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import LinkBox from '@/components/layout/LinkBox.vue'

export default {
  components: {
    PageHeadingInfo,
    TextBoxTitle,
    LinkBox
  },
  data () {
    return {}
  }
}
</script>
